import { analyticsConstants } from "../constants/ActionTypes";
import { baseUrl } from '../constants/baseUrl';

export const getGrossSalesToday = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_GROSS_SALES_TODAY,
    payload: paramObj,
    meta: {
        type: 'apijson',
        url: baseUrl + '/gross_orders',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
            date_first: paramObj.dateFirst,
            date_second: paramObj.dateSecond,
            time_block: paramObj.timeBlock,
        },
        options: {
            method: 'GET'
        }
    }
})